import React from 'react';
import { Spinner } from 'react-bootstrap';

function LoadingSpinner({ 
  size = 'medium', 
  variant = 'primary', 
  text = 'Đang tải...', 
  overlay = false,
  fullScreen = false 
}) {
  const spinnerSizes = {
    small: { width: '1rem', height: '1rem' },
    medium: { width: '2rem', height: '2rem' },
    large: { width: '3rem', height: '3rem' }
  };

  const spinnerStyle = spinnerSizes[size] || spinnerSizes.medium;

  const SpinnerElement = (
    <div className="text-center">
      <Spinner 
        animation="border" 
        variant={variant}
        style={spinnerStyle}
        role="status"
        aria-hidden="true"
      />
      {text && (
        <div className="mt-2 text-muted">
          {text}
        </div>
      )}
    </div>
  );

  if (fullScreen) {
    const fullScreenStyle = {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 9999
    };

    const containerStyle = {
      textAlign: 'center',
      color: 'white',
      animation: 'fadeIn 0.5s ease-in-out'
    };

    const logoStyle = {
      animation: 'pulse 2s infinite'
    };

    return (
      <>
        <style>{`
          @keyframes fadeIn {
            from { opacity: 0; transform: translateY(20px); }
            to { opacity: 1; transform: translateY(0); }
          }
          @keyframes pulse {
            0%, 100% { transform: scale(1); }
            50% { transform: scale(1.05); }
          }
        `}</style>
        <div style={fullScreenStyle}>
          <div style={containerStyle}>
            <div style={logoStyle} className="mb-3">
              <i className="fas fa-warehouse fa-3x text-primary"></i>
            </div>
            {SpinnerElement}
          </div>
        </div>
      </>
    );
  }

  if (overlay) {
    const overlayStyle = {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(255, 255, 255, 0.8)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000,
      borderRadius: '8px'
    };

    const spinnerStyle = {
      background: 'white',
      padding: '2rem',
      borderRadius: '8px',
      boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
    };

    return (
      <div style={overlayStyle}>
        <div style={spinnerStyle}>
          {SpinnerElement}
        </div>
      </div>
    );
  }

  const containerStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '200px'
  };

  return (
    <div style={containerStyle}>
      {SpinnerElement}
    </div>
  );
}

export default LoadingSpinner;
